export const autoReplyCreateTicket = (userName: string | string[]) => {
	return `Olá ${userName}, recebemos sua solicitação.
Neste momento iremos enviar para nossa equipe analisar sua demanda e logo teremos uma resposta.

Equipe Taugor.`;
};
